import React, { useState } from "react";
import axios from "axios";
import { Star, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { API } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function ReviewModal({ onClose }) {
  const [stars, setStars] = useState(0);
  const [hovered, setHovered] = useState(0);
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!stars) return;
    setLoading(true);
    try {
      await axios.post(`${API}/nudge/review`, { stars, text }, { withCredentials: true });
      setDone(true);
    } catch {
      toast.error("Erro ao enviar avaliação");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md mx-4 p-8 relative animate-fade-in-1">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-[#335480]/50 hover:text-[#335480] transition-colors"
        >
          <X size={18} />
        </button>

        {done ? (
          <div className="text-center py-4">
            <div className="text-5xl mb-4">🙏</div>
            <h2 className="text-xl font-bold text-[#001533] mb-2" style={{ fontFamily: "Cabinet Grotesk" }}>
              Obrigado pelo feedback!
            </h2>
            <p className="text-[#335480] mb-6">Sua avaliação nos ajuda a melhorar o TUTO.</p>
            <Button onClick={onClose} className="bg-[#003882] hover:bg-[#00285e] text-white font-semibold px-8">
              Fechar
            </Button>
          </div>
        ) : (
          <>
            <h2 className="text-xl font-bold text-[#001533] mb-1" style={{ fontFamily: "Cabinet Grotesk" }}>
              O que está achando do TUTO?
            </h2>
            <p className="text-[#335480] text-sm mb-6">Sua opinião leva menos de 1 minuto e nos ajuda muito.</p>

            {/* Stars */}
            <div className="flex gap-2 mb-6 justify-center">
              {[1, 2, 3, 4, 5].map(n => (
                <button
                  key={n}
                  onMouseEnter={() => setHovered(n)}
                  onMouseLeave={() => setHovered(0)}
                  onClick={() => setStars(n)}
                  className="transition-transform hover:scale-110"
                >
                  <Star
                    size={36}
                    className={`transition-colors ${
                      n <= (hovered || stars)
                        ? "text-[#f59e0b] fill-[#f59e0b]"
                        : "text-[#D1DEEE] fill-[#D1DEEE]"
                    }`}
                  />
                </button>
              ))}
            </div>

            {stars > 0 && (
              <p className="text-center text-sm text-[#335480] mb-4 -mt-2">
                {["", "Muito insatisfeito", "Insatisfeito", "Neutro", "Satisfeito", "Muito satisfeito"][stars]}
              </p>
            )}

            {/* Text */}
            <textarea
              value={text}
              onChange={e => setText(e.target.value)}
              placeholder="Algum comentário? (opcional)"
              rows={3}
              maxLength={1000}
              className="w-full border border-[#D1DEEE] rounded-lg px-3 py-2 text-sm text-[#001533] placeholder:text-[#335480]/50 focus:outline-none focus:border-[#003882] resize-none mb-5"
            />

            <div className="flex gap-3">
              <Button
                onClick={submit}
                disabled={!stars || loading}
                className="flex-1 bg-[#003882] hover:bg-[#00285e] text-white font-semibold h-11"
              >
                {loading ? (
                  <span className="flex items-center gap-2">
                    <span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Enviando...
                  </span>
                ) : "Enviar avaliação"}
              </Button>
              <Button
                onClick={onClose}
                variant="outline"
                className="border-[#D1DEEE] text-[#335480] h-11 px-4"
              >
                Agora não
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
